// Game
export const SET_GAME_PROCESS: string = 'SET_GAME_PROCESS'
export const SPEND_ONE_MINUTE: string = 'SPEND_ONE_MINUTE'
export const ENABLE_BGM: string = 'ENABLE_BGM'
export const OPEN_MAIN_MENU: string = 'OPEN_MAIN_MENU'
export const SET_IS_MAIN_MENU_CLOSING: string = 'SET_IS_MAIN_MENU_CLOSING'
export const GAME_NOTIFICATION: string = 'GAME_NOTIFICATION'
export const SET_FISHROD_LEVEL: string = 'SET_FISHROD_LEVEL'
export const COMPLETED_TUTORIAL_ENTRY: string = 'COMPLETED_TUTORIAL_ENTRY'

// Inventory
export const ADD_INVENTORY_ENTRY: string = 'ADD_INVENTORY_ENTRY'
export const REMOVE_INVENTORY_ENTRY: string = 'REMOVE_INVENTORY_ENTRY'
export const EARN_MONEY: string = 'EARN_MONEY'
export const SPEND_MONEY: string = 'SPEND_MONEY'

// Fishing
export const MAKE_BAIT_AVAILABLE: string = 'MAKE_BAIT_AVAILABLE'
export const PUT_ON_BAIT_ITEM: string = 'PUT_ON_BAIT_ITEM'
export const BAIT_FALL_IN_WATER: string = 'BAIT_FALL_IN_WATER'
export const SET_HOOKED_FISH: string = 'SET_HOOKED_FISH'
export const SET_LINE_TENSION: string = 'SET_LINE_TENSION'
export const INCREMENT_LINE_TENSION: string = 'INCREMENT_LINE_TENSION'
export const DECREMENT_LINE_TENSION: string = 'DECREMENT_LINE_TENSION'
export const SET_IS_PULLING: string = 'SET_IS_PULLING'

// Position
export const UPDATE_POSITION: string = 'UPDATE_POSITION'